/* Core & libraries */
import React, { useEffect } from 'react'
import { FormattedMessage } from "react-intl";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import {ClipLoader} from "react-spinners";

/* Styles */
import styles from "./styles";
import { colors } from "../../../../../constants/colors";



const CustomPreview = (props) => {

  const theme = useTheme();
  const classes = styles({ theme });

  const {
    fileWithMeta: { cancel, remove, restart },
    meta: { name = '', percent = 0, size = 0, previewUrl, status, duration, validationError },
    nameColumnPresent,
    maskedColumnPresent,
    correctNumberOfCommas,
    advancedNumberColumnPresent,
    tierColumnPresent,
    budgetYearColumnPresent,
    maxTravelersNumber,
    emptyRows,
    errorMessage,
    files,
    isUpload,
    canCancel,
    canRemove,
    canRestart,
    extra: { minSizeBytes },
    setIsUploading,
    fileSize
  } = props

  let title = `${name || '?'}`
  
  let hasError = ['error_upload_params', 'exception_upload', 'aborted'].includes(status) && canRestart || nameColumnPresent === false || correctNumberOfCommas === false || maskedColumnPresent === false || advancedNumberColumnPresent === false || tierColumnPresent === false || budgetYearColumnPresent === false || maxTravelersNumber === true || emptyRows === true;

  if (status === 'error_file_size' || status === 'error_validation'|| status === 'error_upload') {
    hasError = true;
  }

  if (hasError) {
    setIsUploading(false);
  }


  const renderError = () => {
    if (hasError) {
      // the rest of your error logic
      switch (status) {
        case "error_file_size":
          return <span className={classes.errorMessage}>{size < minSizeBytes ? <FormattedMessage id="loyalty.atmBulkImport.errorsFile" /> : <FormattedMessage id="loyalty.atmBulkImport.toBigError" />}</span>;
        case "error_validation":
          return <span className={classes.errorMessage}>{String(validationError)}</span>;
        default:
          return <div className={classes.tryAgain} onClick={remove}><FormattedMessage id="loyalty.atmBulkImport.tryAgain" /></div>;
      }
    }
  }

  const renderSelectedFileFailedMessage = () => {
    let conditionKey;

    if (nameColumnPresent === false) {
      conditionKey = 'nameColumn';
    } else if (maskedColumnPresent === false) {
      conditionKey = 'maskedColumn';
    } else if (advancedNumberColumnPresent === false) {
      conditionKey = 'advancedNumberColumn';
    } else if (tierColumnPresent === false) {
      conditionKey = 'tierColumn';
    } else if (maxTravelersNumber === true) {
      conditionKey = 'maxTravelers';
    } else if (correctNumberOfCommas === false) {
      conditionKey = 'incorrectCommas';}
    else if (emptyRows === true) {
      conditionKey = 'emptyRows';
    } else {
      conditionKey = 'default';
    }

    switch (conditionKey) {
      case 'nameColumn':
        return (
          <span className={classes.errorMessage}>
            <FormattedMessage id="loyalty.atmBulkImport.uploadNotificationName" />
          </span>
        );
      case 'maskedColumn':
        return (
          <span className={classes.errorMessage}>
            <FormattedMessage id="loyalty.atmBulkImport.uploadNotificationMasked" />
          </span>
        );
      case 'advancedNumberColumn':
        return (
          <span className={classes.errorMessage}>
            <FormattedMessage id="loyalty.atmBulkImport.uploadNotificationAdvancedNumber" />
          </span>
        );
      case 'tierColumn':
        return (
          <span className={classes.errorMessage}>
            <FormattedMessage id="loyalty.atmBulkImport.uploadNotificationTier" />
          </span>
        );
      case 'maxTravelers':
        return (
          <span className={classes.errorMessage}>
            <FormattedMessage id="loyalty.atmBulkImport.uploadNotificationMaxTravelers" />
          </span>
        );
      case 'incorrectCommas':
        return (
          <span className={classes.errorMessage}>
            <FormattedMessage id="loyalty.atmBulkImport.invalidFile" />
          </span>
        );
        case 'emptyRows':
        return (
          <span className={classes.errorMessage}>
            <FormattedMessage id="loyalty.atmBulkImport.errorEmpty" />
          </span>
        );
      default:
        return <span className={classes.errorMessage}></span>;
    }
  };

  //note: 'error_upload' set if upload response has HTTP status code >= 400
  const responseErrorStatus = status === 'error_upload';

  return (
    <div className={ hasError || responseErrorStatus || nameColumnPresent === false || correctNumberOfCommas === false || correctNumberOfCommas === false || maskedColumnPresent === false || advancedNumberColumnPresent === false || tierColumnPresent === false || budgetYearColumnPresent === false || emptyRows === true || maxTravelersNumber === true ? classes.previewError : classes.preview}>
      {
        hasError || responseErrorStatus ?
          <span className={classes.fileRedIcon} />
          :
          <span className={classes.fileIcon} />
      }
      <div className={classes.content}>
        {
          hasError &&
          <div className={classes.wrapper}>
            {renderSelectedFileFailedMessage()}
          </div>
        }
        {
          responseErrorStatus &&
          <div className={classes.wrapper}>
            <span className={classes.errorMessage}>{errorMessage}</span>
          </div>
        }
        <div className={classes.wrapper}>
          <div className={classes.titleDiv}>
            <span className={hasError || responseErrorStatus ? classes.titleError : classes.title}>
             {title}
            </span>
              { !hasError && !responseErrorStatus && (
                <span className={classes.title}><FormattedMessage id='loyalty.atmBulkImport.bulkImportSize' values={{size: fileSize}} /></span>
              )}
          </div>
          {nameColumnPresent && maskedColumnPresent && advancedNumberColumnPresent && tierColumnPresent && budgetYearColumnPresent && correctNumberOfCommas && emptyRows && !maxTravelersNumber && (status === 'ready' || status === 'headers_received') && canRemove && (
            <>
              <span className={classes.icon}/>
            </>
          )}
          {status === 'preparing' && (
            <>
              <ClipLoader className={classes.spinner} color={colors.blue700}/>
            </>

          )}
        </div>
        {
          renderError()
        }
      </div>

    </div>
  )
}

export default CustomPreview